import { useEffect, useRef, useState } from 'react'
import { isAnyBlank } from '../../utils/string'
import {
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  TextField
} from '@mui/material'
import AsignaturaSelector from '../../components/form/AsignaturaSelector/AsignaturaSelector'
import css from './ModalNuevoGuion.module.css'

const ModalNuevoGuion = ({ open, onSubmit, onClose, isLoading }) => {
  const [guion, setGuion] = useState({
    nombre: '',
    asignaturas: []
  })

  const [selectedFile, setSelectedFile] = useState(null)
  const inputRef = useRef(null)

  useEffect(() => {
    if (open) {
      setGuion({ nombre: '', asignaturas: [] })
      setSelectedFile(null)
    }
  }, [open])

  const isSubmitDisabled = isAnyBlank(guion.nombre) || !selectedFile

  const handleSubmit = () => {
    onSubmit({
      nombre: guion.nombre,
      archivo: selectedFile,
      asignaturas: guion.asignaturas
    })
  }

  const handleFileChange = e => {
    if (e.target.files.length > 0) {
      setSelectedFile(e.target.files[0])
    }
  }

  const handleUploadClick = () => {
    inputRef.current?.click()
  }

  return (
    <Dialog onClose={onClose} open={open} fullWidth maxWidth='md'>
      <DialogTitle>Nuevo guion</DialogTitle>
      <DialogContent className={css.main}>
        <DialogContentText className={css.intro}>
          Utiliza este formulario para crear un nuevo guion
        </DialogContentText>
        <TextField
          className={css.input}
          label='Nombre'
          value={guion.nombre}
          onChange={e => setGuion({ ...guion, nombre: e.target.value })}
          variant='standard'
        />
        <AsignaturaSelector
          multiple
          className={css.input}
          name='asignatura'
          label='Asignatura'
          value={guion.asignaturas}
          onChange={(_e, value) =>
            setGuion({ ...guion, asignaturas: value.map(a => a.id) || [] })
          }
        />
        <div className={css.file}>
          <p>Adjuntar archivo PDF del guion</p>
          <Button size='small' type='secondary' onClick={handleUploadClick}>
            Seleccionar guion
          </Button>
          <input
            ref={inputRef}
            type='file'
            accept='application/pdf'
            name='pdf'
            onChange={handleFileChange}
            hidden
          />
          {selectedFile && (
            <span className={css.filename}>{selectedFile.name}</span>
          )}
        </div>
      </DialogContent>
      <DialogActions>
        <Button color='error' onClick={onClose}>
          Cancelar
        </Button>
        <Button
          disabled={isSubmitDisabled || isLoading}
          color='primary'
          onClick={handleSubmit}
          startIcon={isLoading && <CircularProgress size={12} />}
        >
          Enviar
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default ModalNuevoGuion
